import { Link } from "react-router-dom";

const ETAPES_GENERALES = [
  {
    numero: "01",
    icon: "fas fa-store",
    titre: "Parcourez nos catégories",
    description:
      "Explorez nos différentes collections : Tablettes, Mendiants, Créations Florales, Cafés Gourmands, Box Découverte et Événements. Prenez le temps de découvrir chaque produit.",
  },
  {
    numero: "02",
    icon: "fas fa-sliders-h",
    titre: "Personnalisez votre commande",
    description:
      "Pour chaque produit, choisissez vos options : goûts, couleurs, emballages, quantités. Le bouton d'ajout au panier se débloque uniquement quand votre sélection est complète.",
  },
  {
    numero: "03",
    icon: "fas fa-shopping-basket",
    titre: "Vérifiez votre panier",
    description:
      "Cliquez sur l'icône panier en haut à droite. Vérifiez vos articles, les quantités et le détail de chaque personnalisation avant de continuer.",
  },
  {
    numero: "04",
    icon: "fas fa-user",
    titre: "Remplissez vos informations",
    description:
      "Dans la page panier, renseignez votre nom, prénom, numéro de téléphone et adresse. Ces informations nous permettent de vous contacter pour confirmer et livrer votre commande.",
  },
  {
    numero: "05",
    icon: "fas fa-paper-plane",
    titre: "Envoyez votre commande",
    description:
      "Cliquez sur \"Envoyer la commande\". Votre demande nous parvient directement. Nous vous recontactons rapidement pour confirmer les détails et organiser la livraison.",
  },
  {
    numero: "06",
    icon: "fas fa-heart",
    titre: "Recevez votre commande",
    description:
      "Une fois confirmée, votre commande est préparée avec soin. Vous serez informé(e) dès qu'elle est prête !",
  },
];

const CATEGORIES_DETAIL = [
  {
    icon: "fas fa-spa",
    titre: "Créations Florales",
    lien: "/categories/creations-florales",
    couleur: "bg-pink-50 border-pink-200",
    iconColor: "text-pink-400",
    etapes: [
      "Choisissez votre bouquet (Bouquet Royal, Bouquet Élégant, Sac Fleuri ou Jardin Gourmand)",
      "Pour le Bouquet Élégant : sélectionnez d'abord la taille (7, 10 ou 20 roses)",
      "Répartissez vos roses entre les 6 goûts disponibles : Praliné Royal, Nuit Gourmand, Neige Croquante, Rose d'Orient, Cœur de Lait Cœur Pistache, Cœur de Lait Praliné Noisette — jusqu'à atteindre le nombre exact de roses du bouquet",
      "Choisissez la couleur de l'emballage (papier, boîte ou sac selon le bouquet)",
      "Choisissez la quantité de bouquets puis ajoutez au panier",
    ],
    note: "Le bouton d'ajout au panier reste grisé tant que vous n'avez pas choisi tous vos goûts ET votre emballage.",
  },
  {
    icon: "fas fa-circle",
    titre: "Mendiants",
    lien: "/categories/mendiants",
    couleur: "bg-amber-50 border-amber-200",
    iconColor: "text-amber-500",
    etapes: [
      "Choisissez entre une boîte standard (8 ou 16 pièces) ou une boîte personnalisée",
      "Pour la boîte personnalisée : sélectionnez vos mendiants un par un selon les saveurs proposées",
      "Ajustez la quantité de boîtes puis ajoutez au panier",
    ],
    note: null,
  },
  {
    icon: "fas fa-chess-board",
    titre: "Tablettes",
    lien: "/categories/tablettes",
    couleur: "bg-brown-50 border-yellow-200",
    iconColor: "text-yellow-700",
    etapes: [
      "Parcourez les tablettes fourrées et garnies disponibles",
      "Cliquez sur une tablette pour voir sa fiche détaillée",
      "Choisissez la quantité et ajoutez au panier",
    ],
    note: null,
  },
  {
    icon: "fas fa-coffee",
    titre: "Cafés Gourmands",
    lien: "/categories/cafes-gourmands",
    couleur: "bg-stone-50 border-stone-200",
    iconColor: "text-stone-500",
    etapes: [
      "Choisissez le nombre de coffrets souhaités",
      "Le contenu du coffret est précomposé — ajoutez directement au panier",
    ],
    note: null,
  },
  {
    icon: "fas fa-gift",
    titre: "Box Découverte",
    lien: "/categories/box-decouverte",
    couleur: "bg-purple-50 border-purple-200",
    iconColor: "text-purple-400",
    etapes: [
      "La Box Découverte contient 1 tablette + 8 mendiants",
      "Choisissez votre tablette parmi les options disponibles",
      "Sélectionnez vos 8 mendiants selon vos goûts",
      "Ajoutez au panier une fois votre sélection complète",
    ],
    note: "La box est un coffret surprise idéal pour offrir ou découvrir nos produits.",
  },
  {
    icon: "fas fa-star",
    titre: "Événements",
    lien: "/categories/evenements",
    couleur: "bg-rose-50 border-rose-200",
    iconColor: "text-rose-400",
    etapes: [
      "Consultez nos créations spéciales pour mariages, baptêmes, anniversaires…",
      "Pour les commandes événementielles (grandes quantités), utilisez le formulaire de devis sur la page Événements",
      "Nous vous recontactons pour personnaliser votre commande selon vos besoins",
    ],
    note: "Pour les événements, nous recommandons de commander au minimum 2 semaines à l'avance.",
  },
  {
  icon: "fas fa-heart",
  titre: "Cœurs en Chocolat",
  lien: "/categories/coeurs-chocolat",
  couleur: "bg-red-50 border-red-200",
  iconColor: "text-red-400",
  etapes: [
    "Choisissez le goût du cœur : Blanc, Noir ou Au Lait",
    "Choisissez le goût de la Fleur Pivoine parmi les 4 goûts disponibles",
    "Répartissez vos 3 roses entre les 4 goûts disponibles",
    "Répartissez vos 6 mendiants entre les 5 goûts : Noir, Lait, Blanc, Gold, Ruby",
    "Ajoutez une demande particulière si souhaité (optionnel)",
    "Choisissez la quantité et ajoutez au panier",
  ],
  note: "Le bouton reste grisé tant que toutes les sélections ne sont pas complètes.",
},
{
  icon: "fas fa-seedling",
  titre: "Fraises Enrobées",
  lien: "/categories/fraises-enrobees",
  couleur: "bg-red-50 border-red-200",
  iconColor: "text-red-400",
  etapes: [
    "La boîte contient 12 fraises enrobées au chocolat",
    "Répartissez vos 12 fraises entre les 3 enrobages : Chocolat au Lait, Blanc et Gold",
    "Ajoutez la quantité souhaitée et ajoutez au panier",
  ],
  note: "Le bouton reste grisé tant que vous n'avez pas réparti vos 12 fraises.",
},
];

const CommentCommander = () => {
  return (
    <div className="section-padding">
      {/* Hero */}
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold mb-4">Comment commander ?</h1>
        <p className="text-gray-500 text-lg max-w-2xl mx-auto">
          Suivez ces étapes simples pour passer votre commande en toute sérénité.
          En cas de doute, n'hésitez pas à nous{" "}
          <Link to="/contact" className="text-primary underline">
            contacter
          </Link>
          .
        </p>
      </div>

      {/* Étapes générales */}
      <div className="mb-20">
        <h2 className="text-2xl font-semibold mb-10 text-center">
          Les étapes de votre commande
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ETAPES_GENERALES.map((etape) => (
            <div
              key={etape.numero}
              className="bg-white rounded-2xl shadow p-6 flex gap-4 items-start"
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <i className={`${etape.icon} text-primary text-lg`}></i>
              </div>
              <div>
                <span className="text-xs font-bold text-primary/50 tracking-widest">
                  ÉTAPE {etape.numero}
                </span>
                <h3 className="font-semibold text-base mb-1">{etape.titre}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {etape.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Détail par catégorie */}
      <div>
        <h2 className="text-2xl font-semibold mb-4 text-center">
          Guide par catégorie
        </h2>
        <p className="text-center text-gray-500 text-sm mb-10">
          Certaines catégories ont des options de personnalisation spécifiques.
          Voici comment les utiliser.
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          {CATEGORIES_DETAIL.map((cat) => (
            <div
              key={cat.titre}
              className={`rounded-2xl border p-6 ${cat.couleur}`}
            >
              {/* Header catégorie */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm">
                  <i className={`${cat.icon} ${cat.iconColor} text-lg`}></i>
                </div>
                <h3 className="font-semibold text-lg">{cat.titre}</h3>
                <Link
                  to={cat.lien}
                  className="ml-auto text-xs text-primary font-medium hover:underline flex items-center gap-1"
                >
                  Voir la page <i className="fas fa-arrow-right text-xs"></i>
                </Link>
              </div>

              {/* Étapes */}
              <ol className="space-y-2 mb-3">
                {cat.etapes.map((etape, i) => (
                  <li key={i} className="flex gap-2 text-sm text-gray-700">
                    <span className="flex-shrink-0 w-5 h-5 rounded-full bg-white border text-xs font-bold flex items-center justify-center shadow-sm">
                      {i + 1}
                    </span>
                    <span>{etape}</span>
                  </li>
                ))}
              </ol>

              {/* Note */}
              {cat.note && (
                <div className="mt-3 flex gap-2 items-start bg-white/70 rounded-xl px-3 py-2">
                  <i className="fas fa-lightbulb text-yellow-500 text-sm mt-0.5 flex-shrink-0"></i>
                  <p className="text-xs text-gray-600">{cat.note}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* CTA final */}
      <div className="mt-16 text-center bg-primary/5 rounded-2xl p-10">
        <h3 className="text-xl font-semibold mb-2">Prêt(e) à commander ?</h3>
        <p className="text-gray-500 mb-6">
          Explorez nos produits et créez votre commande personnalisée.
        </p>
        <div className="flex justify-center gap-4 flex-wrap">
          <Link
            to="/"
            className="btn-primary px-8 py-3 rounded-xl font-semibold"
          >
            Voir nos produits
          </Link>
          <Link
            to="/contact"
            className="border border-primary text-primary px-8 py-3 rounded-xl font-semibold hover:bg-primary hover:text-white transition-colors"
          >
            Nous contacter
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CommentCommander;